import { Component, forwardRef, Input, OnInit } from "@angular/core";

import {
  ControlValueAccessor,
  DefaultValueAccessor,
  NG_VALUE_ACCESSOR,
} from "@angular/forms";

export const CUSTOM_PIN_INPUT_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => DefaultValueAccessor),
  multi: true,
};

@Component({
  selector: "pin-code-input",
  templateUrl: "./pin-code-input.component.html",
  styleUrls: ["./pin-code-input.component.scss"],
  providers: [CUSTOM_PIN_INPUT_CONTROL_VALUE_ACCESSOR, DefaultValueAccessor],
})
export class PinCodeInputComponent implements ControlValueAccessor, OnInit {
  @Input("hideCode") public hideCode: boolean = true;

  public value: string = "";
  public disabled: boolean = false;

  public validateInput(e: any) {
    const el = e.target;
    if (el.validity.patternMismatch) {
      el.value = el.value.slice(0, -1);
      return false;
    }
    return true;
  }

  public onChange: any = () => {};
  public onTouch: any = () => {};

  public writeValue(value: string): void {
    this.value = value;
  }

  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  public updateValue(event: Event): void {
    if (!this.validateInput(event)) {
      return;
    }
    const newValue = (event.target as HTMLInputElement).value;
    this.value = newValue;
    this.onChange(newValue);
    this.onTouch();
  }

  public ngOnInit(): void {}
}



// WEBPACK FOOTER //
// ./src/app/common/pin-code-input/pin-code-input.component.ts